<template>
  <div>

    <md-list class="md-double-line">
      <md-list-item
        v-for="(event, index) in events"
        v-if="(event.dateTime > new Date()) || (new Date() - new Date(event.date) <= 86400000)"
        :key="index">
        <div class="md-list-text-container">
          <span>
            <router-link :to="{ name: 'Event', params: { eventId: event.id } }">
              {{ event.name }}
            </router-link>
          </span>
          <span class="jpCaption">
            {{ event.host }}
          </span>
          <p>
            {{ getEventSchedule(event.startTime, event.endTime) }}
          </p>
        </div>
        <md-chip
          v-if="event.type === 'Class'"
          class="md-primary"
          key="eventClass">クラス</md-chip>
        <md-chip
          v-else-if="event.type === 'Céilí'"
          class="md-accent"
          key="eventCeili">ケーリー</md-chip>
          <md-chip
            v-else-if="event.type === 'SessionOrDance'"
            class="md-primary"
            key="evnetCeili">セッション/ダンス</md-chip>
        <md-divider></md-divider>
      </md-list-item>
    </md-list>

    <md-divider></md-divider>

    <div class="event-controller">
      <router-link
        tag="md-button"
        :to="{ name: 'AllEvent' }"
        class="md-raised">過去のイベントをみる</router-link>
      <router-link
        tag="md-button"
        :to="{ name: 'AddEvent' }"
        class="md-raised md-primary">イベントを作成する</router-link>
    </div>

  </div>
</template>

<script>
import db from '../db'
import { getIdFromURL } from 'vue-youtube-embed'

// db.ref('/events/').remove()

export default {
  name: 'setList',
  data () {
    return {
      sets: {},
      events: {}
    }
  },
  firebase: {
    events: db.ref('/events').orderByChild('dateTime').startAt(Date.parse(new Date()))
  },
  computed: {
  },
  created () {
    // let self = this
    // db.ref('/events').orderByChild('dateTime').once('value').then(function (events) {
    //   self.events = events.val()
    //
    //   for (let eventId in self.events) {
    //     // console.log(eventId, self.events[eventId].name)
    //     // let dateTime = new Date(self.events[eventId].date + 'T' + self.events[eventId].startTime + ':00') // +0900
    //     // let dateTime = new Date(self.events[eventId].date + 'T' + self.events[eventId].endTime + ':00') // +0900
    //     // console.log(self.events[eventId].name, dateTime.toISOString())
    //
    //     // db.ref('/events/' + eventId + '/test').set('aaa')
    //     db.ref('/events/' + eventId + '/_startTime').set(null)
    //     db.ref('/events/' + eventId + '/_endTime').set(null)
    //
    //     // db.ref('/events/' + eventId + '/_endTime').set(dateTime.toISOString())
    //     // db.ref('/events/' + eventId + '/index').set(Date.parse(dateTime) * -1)
    //     // console.log(Date.parse(dateTime) * -1)
    //
    //     // console.log(self.events[eventId].name, dateTime.toISOString().substr(0, 19) + '.090Z')
    //     // console.log(self.events[eventId].name, new Date(dateTime.toISOString().substr(0, 19) + '.090Z'))
    //     // console.log(new Date())
    //     // dateTime = new Date(dateTime.setHours(dateTime.getHours() + 9))
    //   }
    //
    //   // console.log(self.events)
    //
    //   // db.ref('/sets').once('value').then(function (sets) {
    //   //   for (let i in self.event.sets) {
    //   //     let setName = self.event.sets[i]
    //   //     self.$set(self.sets, setName, sets.val()[setName])
    //   //     self.selectedSets.push(setName)
    //   //   }
    //   //   self.$set(self, 'allSets', sets.val())
    //   // })
    // })
  },
  methods: {
    getEventSchedule: function (startTime, endTime) {
      let zeroFill = require('zero-fill')
      startTime = new Date(startTime)
      endTime = new Date(endTime)
      return startTime.getFullYear() + '年' + (startTime.getMonth() + 1) + '月' + startTime.getDate() + '日(' + (['日', '月', '火', '水', '木', '金', '土'][new Date(startTime).getDay()]) + ') ' + new Date(startTime).getHours() + ':' + zeroFill(2, new Date(startTime).getMinutes()) + '-' + new Date(endTime).getHours() + ':' + zeroFill(2, new Date(endTime).getMinutes())
    },
    getHoursAndMinutes: function (dateTime) {
      let zeroFill = require('zero-fill')
      return new Date(dateTime).getHours() + ':' + zeroFill(2, new Date(dateTime).getMinutes())
    },
    getThumbnail: function (url) {
      return 'https://i.ytimg.com/vi/' + getIdFromURL(url) + '/mqdefault.jpg'
    },
    getDescription: function (set) {
      let orders = []
      let rythmns = []
      let description = ''
      for (let i = 0; i < set.figures.length; i++) {
        // variation のあるフィガーのリズムを重複して表示しないようにする
        if (orders.indexOf(set.figures[i].order) < 0) {
          description += i !== 0 ? ' - ' + set.figures[i].rythmn : set.figures[i].rythmn
          orders.push(set.figures[i].order)
          rythmns.push(set.figures[i].rythmn)
        }
      }

      // すべてのフィガーが同じリズムのとき
      if (Array.from(new Set(rythmns)).length === 1) {
        return 'All ' + Array.from(new Set(rythmns))[0] + 's'
      }

      return description
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  /*display: inline-block;*/
  margin: 0 10px;
}

.jpCaption {
  font-size: 12px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// NextEvents.vue?7ba825e4